// extracted by css-extract-rspack-plugin
export default {"modal":"b7TWUT","root":"GzmvUu","footer":"yT601T"};